import { CloseIcon } from "@chakra-ui/icons";
import {
  Box,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerOverlay,
  Flex,
  Image,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  Text,
  useBreakpointValue,
} from "@chakra-ui/react";
import GCPImage from "components/GCPImage";
import { useRouter } from "next/router";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
const DetailContent = ({ detail, onClose }) => {
  const { t } = useTranslation();
  return (
    <Box>
      <Flex
        px={{ base: "16px", lg: "32px" }}
        pt={{ base: "16px", lg: "32px" }}
        h={{ base: "64px", lg: "64px" }}
        justifyContent="flex-end"
      >
        <Flex
          mt={{ base: "0px", lg: "-16px" }}
          w="40px"
          h="40px"
          bg="#F3F4F9"
          borderRadius="20px"
          alignItems="center"
          justifyContent="center"
          cursor="pointer"
          onClick={() => onClose()}
        >
          <CloseIcon w="14px" h="14px" />
        </Flex>
      </Flex>

      <Box mb="16px" px={{ base: "16px", lg: "32px" }} w="100%">
        <Text mb="24px" textStyle="notoH24" color="#333333">
          {t("Station_detail_modal_title")}
        </Text>

        {detail?.logo && (
          <Image mb="8px" src={detail?.logo} alt="logo" h="40px" />
        )}

        {detail?.name && (
          <Flex alignItems="center">
            <Flex
              w="40px"
              h="40px"
              bg="#F3F4F9"
              borderRadius="8px"
              justify="center"
              align="center"
              mr="16px"
            >
              <GCPImage
                src="/images/icons/building.png"
                alt="image"
                w="24px"
                h="24px"
              />
            </Flex>

            <Box w="100%" py="16px" borderBottom="1px solid rgba(0, 0, 0, 0.1)">
              <Text textStyle="notoP14" color="#748598">
                {t("Station_detail_modal_name")}
              </Text>

              <Text textStyle="notoH14" color="#333333">
                {detail?.name}
              </Text>
            </Box>
          </Flex>
        )}

        {detail?.address && (
          <Flex alignItems="center">
            <Flex
              w="40px"
              h="40px"
              bg="#F3F4F9"
              borderRadius="8px"
              justify="center"
              align="center"
              mr="16px"
            >
              <GCPImage
                src="/images/icons/map.png"
                alt="image"
                w="24px"
                h="24px"
              />
            </Flex>

            <Flex
              alignItems="center"
              justifyContent="space-between"
              w="100%"
              borderBottom="1px solid rgba(0, 0, 0, 0.1)"
              cursor="pointer"
              onClick={() => {
                navigator.clipboard.writeText(detail?.address);
                toast.success(t("Invite_copy_link_success"));
              }}
            >
              <Box w="100%" py="16px">
                <Text textStyle="notoP14" color="#748598">
                  {t("Station_detail_modal_address")}
                </Text>

                <Text textStyle="notoH14" color="#333333">
                  {detail?.address}
                </Text>
              </Box>

              <GCPImage
                src="/images/icons/copy.png"
                alt="image"
                w="24px"
                h="24px"
              />
            </Flex>
          </Flex>
        )}

        {detail?.worktime && (
          <Flex alignItems="center">
            <Flex
              w="40px"
              h="40px"
              bg="#F3F4F9"
              borderRadius="8px"
              justify="center"
              align="center"
              mr="16px"
            >
              <GCPImage
                src="/images/icons/time.png"
                alt="image"
                w="24px"
                h="24px"
              />
            </Flex>

            <Box w="100%" py="16px" borderBottom="1px solid rgba(0, 0, 0, 0.1)">
              <Text textStyle="notoP14" color="#748598">
                {t("Station_detail_modal_worktime")}
              </Text>

              <Text textStyle="notoH14" color="#333333">
                {detail?.worktime}
              </Text>
            </Box>
          </Flex>
        )}

        {detail?.phone && (
          <Flex alignItems="center">
            <Flex
              w="40px"
              h="40px"
              bg="#F3F4F9"
              borderRadius="8px"
              justify="center"
              align="center"
              mr="16px"
            >
              <GCPImage
                src="/images/icons/phone.png"
                alt="image"
                w="24px"
                h="24px"
              />
            </Flex>

            <Box w="100%" py="16px" borderBottom="1px solid rgba(0, 0, 0, 0.1)">
              <Text textStyle="notoP14" color="#748598">
                {t("Station_detail_modal_phone")}
              </Text>

              <Text textStyle="notoH14" color="#333333">
                {detail?.phone}
              </Text>
            </Box>
          </Flex>
        )}
      </Box>
    </Box>
  );
};

const StationDetailModal = ({ isOpen, onClose, detail }) => {
  const isLgUp = useBreakpointValue({ base: false, lg: true });
  const router = useRouter();
  if (!isLgUp) {
    return (
      <Drawer
        isOpen={isOpen && !isLgUp}
        onClose={onClose}
        size="4xl"
        placement="bottom"
      >
        {router.pathname !== "/station/carInfo" && (
          <Box
            pos="absolute"
            top="0"
            left="0"
            bg="rgba(0, 0, 0, 0.5)"
            w="100%"
            h="100vh"
            zIndex={1700}
            onClick={() => onClose()}
          ></Box>
        )}

        <DrawerOverlay />

        <Box zIndex={1800} pos="relative">
          <DrawerContent borderTopRadius="16px">
            <DrawerBody p="0px" maxH="95dvh" minH="95dvh">
              <DetailContent detail={detail} onClose={onClose} />
            </DrawerBody>
          </DrawerContent>
        </Box>
      </Drawer>
    );
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="4xl">
      {router.pathname !== "/station/carInfo" && (
        <Box
          pos="absolute"
          top="0"
          left="0"
          bg="rgba(0, 0, 0, 0.5)"
          w="100%"
          h="100vh"
          zIndex={1700}
          onClick={() => onClose()}
        ></Box>
      )}
      <ModalOverlay />

      <Box zIndex={1800} pos="relative">
        <ModalContent p="0px" borderRadius="16px">
          <ModalBody p="0px" minH="80vh">
            <DetailContent detail={detail} onClose={onClose} />
          </ModalBody>
        </ModalContent>
      </Box>
    </Modal>
  );
};

export default StationDetailModal;
